// removed by extract-text-webpack-plugin
module.exports = {"box":"_1mkcWLAun4D_sVs71YOjbj","header":"_3UfGOa5MGp09dIsYco9fka","webcams":"_3FV6H41KiOpF9iE1-o7VeO","infographics":"_2u8AYBhV87cuAn4wpwcP","indicators":"_3Xr4Lu0L2EWDRD_Lb22-HV","active":"VqaeaDI0xy4NvcrvnHzy1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RightNowBox/RightNowBox.module.scss
// module id = 805
// module chunks = 0